import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterableFields',
    standalone: true,
})
export class FilterableFieldsPipe implements PipeTransform {
    transform(columns: any[]): string[] {
        if (!Array.isArray(columns)) {
            return [];
        }

        return columns.reduce((acc, col) => {
            if (col.filter && col.filter.field) {
                acc.push(col.filter.field);
            }
            return acc;
        }, [] as string[]);
    }
}
